
import Vue from "vue";
import { Dialog } from "@/lib/utils";
import EditorStyleSettingsModal from "@/components/ui/EditorStyleSettingsModal.vue";

export default Vue.extend({
  methods: {
    cancel() {
      this.$close(false);
    },
    onSelectColorTheme(event) {
      this.$store.dispatch("manuscriptModule/selectTheme", event.target.value);
    },
    openEditorStyleSettings() {
      this.$close(false);
      const dialog = new Dialog(EditorStyleSettingsModal);
      dialog.show({ source: "writing" });
    },
  },
  computed: {
    theme() {
      return this.$store.getters["manuscriptModule/theme"];
    },
  },
});
